export const yodaInfoConstants = {
  GETCOOKIE_ALL_REQUEST: "YODAINFO_GETCOOKIE_ALL_REQUEST",
  GETCOOKIE_ALL_SUCCESS: "YODAINFO_GETCOOKIE_ALL_SUCCESS",
  GETCOOKIE_ALL_FAILURE: "YODAINFO_GETCOOKIE_ALL_FAILURE",

  GETPRIVACY_ALL_REQUEST: "YODAINFO_GETPRIVACY_ALL_REQUEST",
  GETPRIVACY_ALL_SUCCESS: "YODAINFO_GETPRIVACY_ALL_SUCCESS",
  GETPRIVACY_ALL_FAILURE: "YODAINFO_GETPRIVACY_ALL_FAILURE",

  GETSCALESIZE_ALL_REQUEST: "YODAINFO_GETSCALESIZE_ALL_REQUEST",
  GETSCALESIZE_ALL_SUCCESS: "YODAINFO_GETSCALESIZE_ALL_SUCCESS",
  GETSCALESIZE_ALL_FAILURE: "YODAINFO_GETSCALESIZE_ALL_FAILURE",
};
